<template>
<!--:modal="false" :close-on-click-modal="false"  -->
  <el-dialog ref='dialog' title="导入数据" >
    <div class="form-tips fz-14 m-b-10">
      <span v-if="!this.onlyName">输入格式为“选项值|选项名称”，每行一条。(选项值为数字类型)</span>
      <span v-if="this.onlyName">输入格式为“选项名称”，每行一条。</span>
      <span>(输入内容为空时，点击保存会清空该控件配置数据。)</span></div>
    <el-input
    type="textarea"
    :rows="8"
    placeholder="请输入内容"
    v-model="text">
  </el-input>
    <div class="footer">
      <el-button @click="closeDialog()">取消</el-button>
      <el-button type="primary" @click="submitData()">保存</el-button>
    </div>
  </el-dialog>
</template>
<style>
</style>

<script>
  import _verify from '../../../assets/js/verify'
  export default {
    props: ['selectConfig', 'onlyName'],
    data() {
      return {
        text: null
      }
    },
    methods: {
      openDialog() {
        if (!this.onlyName) {
          this.reversalText()
        } else {
          this.reversalTextByOnlyName()
        }
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      transFormText() {
        let str = this.text
        let tempArr = []
        // 1 截一行数据
        let arr = str.split('\n')
        let isFormat = true
        // 2 剔除文本中的空格
        if (arr && arr.length > 0) {
          _(arr).forEach((res) => {
            let obj = {}
            let str = res.replace(/\s/g, '')
            // 3 根据 | 截取数据
            let str1 = str.split('|')
            if (str1 && str1.length > 1) {
              if (!_verify.isNumber(str1[0])) {
                isFormat = false
                return
              }
              obj = {
                value: _.toNumber(str1[0]),
                name: str1[1]
              }
              tempArr.push(obj)
              return
            }
            // _g.toastMsg(this, 'error', '导入格式错误')
          })
          if (!isFormat) {
            _g.toastMsg(this, 'error', '导入数据中配置值只能输入数字')
          }
          // this.$emit('handleResult', tempArr)
          store.state.importConfigData = tempArr
          store.dispatch('closeImportDialog', true)
          // this.closeDialog()
        }
      },
      transFormTextByOnlyName() {
        let str = this.text
        let tempArr = []
        let arr = str.split('\n') // 1 截一行数据
        if (arr && arr.length > 0) {  // 2 剔除文本中的空格
          _(arr).forEach((res) => {
            let obj = {}
            let str = res.replace(/\s/g, '')
            obj = {
              name: str
            }
            tempArr.push(obj)
            return
          })
          store.state.importConfigData = tempArr
          store.dispatch('closeImportDialog', true)
          // this.closeDialog()
        }
      },
      reversalText() {
        let str = ''
        _(this.selectConfig).forEach((res, index) => {
          if (this.selectConfig.length - 1 === index) {
            str += `${res.value}|${res.name}`
            return
          }
          str += `${res.value}|${res.name}\n`
        })
        this.text = str
      },
      reversalTextByOnlyName() {
        let str = ''
        _(this.selectConfig).forEach((res, index) => {
          if (this.selectConfig.length - 1 === index) {
            str += `${res.name}`
            return
          }
          str += `${res.name}\n`
        })
        this.text = str
      },
      submitData() {
        // 提交数据
        if (this.text) {
          // 转化文本数据
          if (this.onlyName) {
            this.transFormTextByOnlyName()
          } else {
            this.transFormText()
          }
        } else {
          let tempArr = null
          store.state.importConfigData = tempArr
          store.dispatch('closeImportDialog', true)
          // this.closeDialog()
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// importConfigDialog.vue?95420f16